// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SEQKz","colMin":"styles_colMin__O6EsQ"};